import { render, staticRenderFns } from "./AllColleaguesTable.vue?vue&type=template&id=9d71be02&scoped=true&"
import script from "./AllColleaguesTable.vue?vue&type=script&lang=js&"
export * from "./AllColleaguesTable.vue?vue&type=script&lang=js&"
import style0 from "./AllColleaguesTable.vue?vue&type=style&index=0&id=9d71be02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d71be02",
  null
  
)

export default component.exports